import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="border-b bg-white sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/images/icon48.png" alt="Football Scores" className="w-10 h-10" />
            <h1 className="text-xl font-bold text-gray-900">Football Live Scores</h1>
          </Link>
          <Link to="/">
            <Button variant="ghost">Back to Home</Button>
          </Link>
        </div>
      </header>

      {/* Contact Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 text-center">Contact Us</h1>
        
        <Card className="shadow-lg">
          <CardContent className="p-8">
            <div className="text-center mb-8">
              <div className="text-6xl mb-4">📧</div>
              <h2 className="text-2xl font-bold mb-4">Get in Touch</h2>
              <p className="text-gray-600 mb-6">
                Have questions, feedback, or need support? We'd love to hear from you!
              </p>
            </div>

            <div className="bg-gradient-to-r from-green-50 to-blue-50 p-8 rounded-lg text-center mb-8">
              <p className="text-gray-700 mb-3 font-semibold">Email us at:</p>
              <a 
                href="mailto:football.livescores1@gmail.com" 
                className="text-3xl font-bold text-[hsl(var(--primary))] hover:underline"
              >
                football.livescores1@gmail.com
              </a>
            </div>

            <div className="space-y-6">
              <div>
                <h3 className="font-bold text-lg mb-2">📝 General Inquiries</h3>
                <p className="text-gray-600">
                  Questions about the extension, features, or pricing? Send us an email and we'll get back to you as soon as possible.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">🛠️ Technical Support</h3>
                <p className="text-gray-600">
                  Experiencing issues with the extension? Let us know the details and we'll help you troubleshoot.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">💡 Feature Requests</h3>
                <p className="text-gray-600">
                  Have ideas for new features or improvements? We're always looking to make the extension better!
                </p>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">🤝 Partnerships</h3>
                <p className="text-gray-600">
                  Interested in partnering or collaborating? Reach out and let's discuss opportunities.
                </p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t text-center">
              <p className="text-gray-600 mb-4">
                We typically respond within 24-48 hours
              </p>
              <a href="mailto:football.livescores1@gmail.com">
                <Button className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary-glow))]">
                  Send Email Now
                </Button>
              </a>
            </div>
          </CardContent>
        </Card>

        <div className="mt-8 text-center">
          <Link to="/">
            <Button variant="outline">Back to Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contact;
